import React from 'react';
import { Profile } from '../context/AuthContext';
import {
  formatDiabetesDuration,
  getAgeBand,
  getAgeBandLabel,
  getGenderLabel
} from '../../lib/domain-data';
import { AvatarBadge } from './AvatarPicker';
import { isProfileComplete } from './ProfileFields';

/**
 * FR-02 profile fields on the doctor dashboard, read-only.
 *
 * The family maintains these on /profile. What the clinic needs from this
 * panel is to see them — and to spot a doctor typed in by hand, which is the
 * signal that a doctor account still has to be created and assigned.
 */
const PatientProfileSummary: React.FC<{ patient: Profile }> = ({ patient }) => {
  const band = getAgeBand(patient.birth_date);
  const duration = formatDiabetesDuration(patient.diagnosis_date);
  const doctorUnlisted = !patient.doctor_id && !!patient.doctor_name;

  const rows: [string, React.ReactNode][] = [
    ['Jenis kelamin', getGenderLabel(patient.gender) ?? '—'],
    [
      'Tanggal lahir',
      patient.birth_date ? `${patient.birth_date}${band ? ` (${getAgeBandLabel(band)})` : ''}` : '—'
    ],
    [
      'Tanggal diagnosis',
      patient.diagnosis_date
        ? `${patient.diagnosis_date}${duration ? ` · ${duration}` : ''}`
        : '—'
    ],
    [
      'Dokter',
      patient.doctor_name ? (
        <>
          {patient.doctor_name}
          {doctorUnlisted ? (
            <span className="patient-profile-flag"> belum terdaftar</span>
          ) : null}
        </>
      ) : (
        '—'
      )
    ],
    ['No. rekam medis', patient.medical_record_no ?? '—']
  ];

  return (
    <div className="patient-profile-summary">
      <div className="profile-heading">
        <AvatarBadge avatarId={patient.avatar_id} size={44} />
        <div className="text-sm font-semibold">
          Profil pasien
          {!isProfileComplete(patient) ? (
            <span className="patient-profile-flag"> belum lengkap</span>
          ) : null}
        </div>
      </div>
      <dl className="family-summary">
        {rows.map(([label, value]) => (
          <div key={label} className="family-summary-row">
            <dt>{label}</dt>
            <dd>{value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
};

export default PatientProfileSummary;
